<template>
  <v-layout row wrap class="rules">
    <v-flex md6 sm12>
      <h4 class="heading font-weight-regular mb-3 user-intent">
        If User Says Something Similar To :
      </h4>
      <v-combobox
        v-model="rule.terms"
        :items="[]"
        chips
        outline
        solo
        multiple
        class="rule-combobox"
        @change="normalizeTerms"
      >
        <template v-slot:selection="data">
          <v-chip
            :selected="data.selected"
            class="rule-chip"
            close
            @input="removeTerm(data.item)"
          >
            <strong>{{ data.item }}</strong
            >&nbsp;
          </v-chip>
        </template>
      </v-combobox>
    </v-flex>
    <v-flex md6 sm12>
      <div v-for="(replay, index) in rule.replay" class="replay" :key="index">
        <replay :replay="replay" :blocks="blocks"></replay>
        <v-btn
          v-if="index > 0"
          @click="deleteReplay(index)"
          class="delete-replay"
          fab
          small
          color=""
          ><v-icon color="#666">delete_outline</v-icon></v-btn
        >
      </div>
      <v-layout>
        <v-spacer />
        <v-btn
          class="add-random-replay font-weight-bold"
          flat
          color="third"
          @click="addNewReplay"
          ><v-icon>add</v-icon> Add Another Answer</v-btn
        >
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import _ from "lodash";
import replay from "./replays";
export default {
  name: "rules",
  props: {
    rule: {
      type: Object,
      default: () => {
        return {};
      },
    },
    blocks: {
      type: Array,
      default: () => {
        return [];
      },
    },
    type: {
      type: String,
      default: () => {
        return "rules";
      },
    },
  },
  components: {
    replay,
  },
  data() {
    return {
      initRule: {},
      multiReplay: false,
    };
  },
  beforeMount() {
    this.initRule = _.cloneDeep(this.rule);
    this.multiReplay = this.rule.replay.length > 1;
  },
  methods: {
    async updateRule() {
      try {
        if (this.rule.terms && this.rule.terms.length) {
          await this.$http_bot.put(`/${this.type}/${this.rule.id}`, this.rule);
        }
        let st = _.isEqual(this.rule, this.initRule);

        if (!st && this.rule.terms && this.rule.terms.length) {
          await this.$http_bot.put(`/${this.type}/${this.rule.id}`, this.rule);

          this.initRule = _.cloneDeep(this.rule);
        } else {
          this.$store.dispatch("setSavingStatus", false);
          this.$store.dispatch("setLoader", false);
        }
      } catch (error) {
        throw error;
      }
    },
    removeTerm(term) {
      let index = this.rule.terms.indexOf(term);
      this.rule.terms.splice(index, 1);
    },
    multiReplayUpdate() {
      if (this.multiReplay === false) {
        this.rule.replay.splice(1);
      }
    },
    addNewReplay() {
      this.rule.replay.push({
        blocks: [],
        errorOrEmpty: 0,
        text: "",
        type: "text",
      });
    },
    deleteReplay(index) {
      this.rule.replay.splice(index, 1);
    },
    normalizeTerms(terms) {
      terms[terms.length - 1] = terms[terms.length - 1].toLowerCase();
    },
  },
  watch: {
    rule: {
      async handler(newVal) {
        if (newVal) {
          await this.updateRule();
        }
        this.multiReplay = this.rule.replay.length > 1;
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
